// #BACE60 -> #2B96D8
export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#559CFF',
    alternate: '#0D1C36',
    light: '#eef5ff',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#2899EE',
    contrastText: '#0A5285',
    alternate: '#1C4992',
    light: '#D9EDF7',
  },
  text: {
    primary: '#273645',
    secondary: '#64748B',
    light: '#64748B',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    link: '#90D0FF',
    border: '#E5EAF4',
    header: '#559CFF',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#002B63',
    paper: '#FFF',
    default: '#FFF',
    header: '#0D1C36',
    footer: '#F7F7F7',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#000000',
    icons: '#2A5A75',
    savingsTableHead: '#EDF7FF',
    howItworks: 'rgba(224, 237, 255, 1)',
    filter: 'rgba(224, 237, 255, 1)',
    tableHead: '#000000',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#262626',
    secondary: 'rgb(240,243,243)',
    tertiary: 'rgba(225, 242, 255, 0.6)',
    light: '#F7F7F7',
    secondaryLight: '#FBF7F5',
    freebie: 'rgba(224, 237, 255, 0.3)',
    freebieImage: '#3B4636'
  },
  verticalBar: {
    used: '#559CFF',
    unused: '#559CFF',
    unlimited: '#C0C0C0',
  },
};
